export const ENGINE_VERSION_V2 = '2.0.0'

export type BlockKind =
  | 'video'
  | 'soru'
  | 'tekrar'
  | 'deneme'
  | 'analiz'
  | 'yanlis'
  | 'paragraf'
  | 'kelime'
  | 'catchup'
  | 'plan'
  | 'netgiris'

export type BlockSource = 'ours' | 'generic' | 'system'

export type PlanDayKindV2 = 'normal' | 'deneme' | 'tekrar' | 'minimum'

export interface PlanBlockV2 {
  kind: BlockKind
  subject: string
  mins: number
  seq: number
  source?: BlockSource
  lessonId?: number
  lessonTitle?: string
  topicKey?: string
  pairId?: string
  directive?: string
  part?: string
  time?: string | null
  fixed?: boolean
  core?: boolean
  light?: boolean
  denemeKind?: 'tyt' | 'ayt' | 'brans'
  done?: boolean
}

export interface PlanGroupV2 {
  label: string | null
  blocks: PlanBlockV2[]
}

export interface PlanDayV2 {
  day: string
  date: string
  kind: PlanDayKindV2
  blocks: PlanBlockV2[]
  groups: PlanGroupV2[]
  nextSeq: number
  totalMins: number
}

export type PlanWeekV2 = PlanDayV2[]

export interface BlockKindMeta {
  icon: string
  label: string
}

export const KIND_META: Record<BlockKind, BlockKindMeta> = {
  video: { icon: '📖', label: 'Konu çalışması' },
  soru: { icon: '✏️', label: 'Soru çözümü' },
  tekrar: { icon: '↻', label: 'Tekrar' },
  deneme: { icon: '🎯', label: 'Deneme' },
  analiz: { icon: '🔍', label: 'Deneme analizi' },
  yanlis: { icon: '📕', label: 'Yanlış defteri' },
  paragraf: { icon: '📝', label: 'Paragraf' },
  kelime: { icon: '🔤', label: 'Kelime' },
  catchup: { icon: '🧹', label: 'Yetiştirme' },
  plan: { icon: '🧭', label: 'Plan' },
  netgiris: { icon: '📊', label: 'Net girişi' },
}

export const BLOCK_MINS: Record<BlockKind, number> = {
  video: 50,
  soru: 50,
  tekrar: 40,
  deneme: 135,
  analiz: 45,
  yanlis: 15,
  paragraf: 25,
  kelime: 20,
  catchup: 50,
  plan: 5,
  netgiris: 10,
}

export interface PlanStateV2 {
  area: string
  goal: string
  grade: 'lise' | 'mezun'
  dailyMinutes: number
  kelime: boolean
  dayStart?: string | null
}

export interface CheckInV2 {
  date: string
  energy: number
  minDay: boolean
  checkedIn: boolean
}

export interface TopicProgressV2 {
  topic_key: string
  state: 'active' | 'oturdu' | 'pasif'
  interval_days: number
  next_rep_at: string
  last_score: number | null
  misses: number
  last_done_at?: string
}

export interface PhaseMix {
  video: number
  soru: number
  tekrar: number
}

export const PHASE_MIX: Record<number, PhaseMix> = {
  1: { video: 0.5, soru: 0.35, tekrar: 0.15 },
  2: { video: 0.2, soru: 0.6, tekrar: 0.2 },
  3: { video: 0.3, soru: 0.4, tekrar: 0.3 },
  4: { video: 0, soru: 0.4, tekrar: 0.4 },
}
